module.exports = __webpack_public_path__ + "h5/img/live-logo.69c0d13f.gif";